import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Auth.css';

const FUNCTIONS_BASE = process.env.REACT_APP_FUNCTIONS_BASE || 'https://us-central1-up-convert.cloudfunctions.net';
const AUTH_CALLBACK_URL = `${FUNCTIONS_BASE}/authCallback`;
const DEFAULT_REDIRECT = '/dashboard';

function AuthCallback() {
  const navigate = useNavigate();
  const [status, setStatus] = useState('Linking your Google Workspace account...');
  const [error, setError] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');

    if (!code || !state) {
      setError('Missing authorization details. Please restart the connect flow.');
      return;
    }

    const completeConnection = async () => {
      try {
        setStatus('Adding you to the right workspace...');
        const res = await fetch(AUTH_CALLBACK_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code, state }),
        });

        if (!res.ok) {
          const message = await res.text();
          throw new Error(message || 'Failed to finalize authentication.');
        }

        const data = await res.json().catch(() => ({}));
        let redirectUrl = data.redirectUrl || DEFAULT_REDIRECT;

        // Sanitize redirectUrl to prevent DOM XSS
        const lowerUrl = redirectUrl.toLowerCase();
        // eslint-disable-next-line no-script-url
        if (lowerUrl.startsWith('javascript:') || lowerUrl.startsWith('data:') || lowerUrl.startsWith('vbscript:')) {
          redirectUrl = DEFAULT_REDIRECT;
        }

        setStatus('All set. Redirecting...');
        window.location.replace(redirectUrl);
      } catch (err) {
        setError(err.message || 'Unable to finish connecting your account.');
      }
    };

    completeConnection();
  }, []);

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ textAlign: 'center' }}>
        <p className="eyebrow">Finalizing setup</p>
        <h1>Connecting your account</h1>
        {error ? (
          <>
            <p className="error-text" style={{ marginTop: 12 }}>{error}</p>
            <button
              type="button"
              className="primary-button"
              style={{ width: '100%', marginTop: 18 }}
              onClick={() => navigate('/login', { replace: true })}
            >
              Back to login
            </button>
          </>
        ) : (
          <>
            <div className="loading-graphic" aria-hidden="true" />
            <p className="subhead" style={{ marginTop: 10 }}>{status}</p>
            <p className="subhead" style={{ marginTop: 6, color: '#6b7280' }}>
              You will be redirected automatically once your workspace is ready.
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default AuthCallback;
